<template>
  <BreadCrumb PageTitle="Modifier bon de ramassage" />
  <EditPickup />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import EditPickup from "../../components/PickUp/EditPickup.vue";
import { useRoute } from "vue-router";

export default defineComponent({
  name: "EditPickupPage",
  components: {
    BreadCrumb,
    EditPickup,
  },

  setup: () => {
    const route = useRoute();
    let id = route.params.id;  // <-- get the id
    let refCode = route.params.refCode;  // <-- get the id

    if (Array.isArray(id)) {
      id = id[0] ?? "";
    }

    if (Array.isArray(refCode)) {
      refCode = refCode[0] ?? "";
    }


    return { id, refCode };
  }
});
</script>